export enum ActionTypes {
  Rename = 'RENAME',
  Remove = 'REMOVE',
  AddSubLesson = 'ADD_SUB_LESSON',
  SetOptional = 'SET_OPTIONAL',
}

export enum AddLevels {
  First = 'SECTION_LEVEL',
  Second = 'ROOT_LESSON_LEVEL',
  Third = 'SUB_LESSON_LEVEL',
}
